'use client'

import Box, { BoxProps } from '@mui/material/Box'
import MuiSkeleton, { SkeletonProps as MuiSkeletonProps } from '@mui/material/Skeleton'
import { ReactElement } from 'react'
import { tss } from 'tss-react/mui'

export type SkeletonProps = Omit<MuiSkeletonProps, 'width' | 'className'> & {
    width?: BoxProps['width']
    className?: string
    innerClassName?: string
}

declare module '@mui/material/Skeleton' {
    interface SkeletonPropsVariantOverrides {
        square: true
    }
}

const useStyles = tss.create(() => ({
    square: {
        position: 'relative',
        paddingTop: '100%',

        '& > *': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
        },
    },
}))

function Skeleton({
    width,
    height,
    variant,
    className,
    innerClassName: skeletonClassName,
    ...otherProps
}: SkeletonProps): ReactElement {
    const { classes, cx } = useStyles()

    return (
        <Box
            sx={{ width }}
            component={variant === 'text' ? 'span' : 'div'}
            className={cx(variant === 'square' && classes.square, className)}
        >
            <MuiSkeleton
                animation={variant === 'square' ? 'pulse' : 'wave'} // TODO INOTF-3643 Custom square variant disappears when animation wave is selected
                height={height}
                variant={variant === 'square' ? 'rectangular' : variant}
                className={skeletonClassName}
                {...otherProps}
            />
        </Box>
    )
}

export default Skeleton
